import styled from 'styled-components';
import CancelWrongSvg from '../../assets/mytrips/somthing-wrong-cancel.svg';

const CancelWrongIcon = styled(CancelWrongSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '20.3rem'};
  height: ${props => props.height || '11.7rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default CancelWrongIcon;
